import { EnrichedSelectionTemplate } from './types';

import { makeSearchBoxCriterion } from '@cast/shared-search-ui';

export const openSelectionTplSearchKey = 'selectionTemplate';
export const openKarpenterSearchKey = 'openKarpenter';
export const tableId = 'node-selection-templates';

export const nodeTemplateCriterion =
  makeSearchBoxCriterion<EnrichedSelectionTemplate>({
    key: 'Node template:',
    getValue: (t) => t?.name,
  });

const nodeConfigCriterion = makeSearchBoxCriterion<EnrichedSelectionTemplate>({
  key: 'Configuration:',
  getValue: (t) => t?.configurationName,
});

export const searchBoxCriteria = [nodeTemplateCriterion, nodeConfigCriterion];

export const NODE_TEMPLATES_SPOT_INTERRUPTION_RATIO_LOOKBACK_DAYS = 30;
